export const styles = t => ({
    htmlTooltip: {
        maxWidth: '600px',
        border: '1px solid grey'
    },
    list_item: {
        padding: 0,
        paddingLeft: 24,
        paddingRight: 4
    },
    nested: {
        paddingLeft: 4
    },
    drawer: {
        width: 270,
        flexShrink: 0,
        whiteSpace: "nowrap"
    },
    drawerOpen: {
        width: 270,
        transition: t.transitions.create("width", {
            easing: t.transitions.easing.sharp,
            duration: t.transitions.duration.enteringScreen
        }),
        overflowX: "hidden"
    },
    drawerClose: {
        transition: t.transitions.create("width", {
            easing: t.transitions.easing.sharp,
            duration: t.transitions.duration.leavingScreen
        }),
        overflowX: "hidden",
        width: 0
    },
    listItemText: {
        margin: '0px', padding: '0px', lineHeight: 'normal'
    },
    toolbar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: "0 8px",
        minHeight: "65px",
    },
    toggleButtonOpen: {
        zIndex: 1e3,
        position: "absolute",
        top: "50%",
        right: 270,
        width: 24,
        height: 60,
        backgroundColor: "rgba(228, 228, 228, 1)",
        transition: t.transitions.create("right", {
            easing: t.transitions.easing.sharp,
            duration: t.transitions.duration.enteringScreen
        }),
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end"
    },
    toggleButtonClose: {
        zIndex: 1e3,
        position: "absolute",
        top: "50%",
        width: 24,
        height: 60,
        right: 1,
        backgroundColor: "rgba(228, 228, 228, 1)",
        transition: t.transitions.create("right", {
            easing: t.transitions.easing.sharp,
            duration: t.transitions.duration.leavingScreen
        }),
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    searchButtonOpen: {
        zIndex: 1e3,
        position: "absolute",
        top: 11,
        right: 280,
        width: 50,
        height: 50,
        backgroundColor: "rgba(228, 228, 228, 1)",
        transition: t.transitions.create("right", {
            easing: t.transitions.easing.sharp,
            duration: t.transitions.duration.enteringScreen
        }),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff",
        borderRadius: 5,
        border: "1px solid rgba(0,0,0,1)"
    },
    searchButtonClose: {
        zIndex: 1e3,
        position: "absolute",
        top: 11,
        width: 50,
        height: 50,
        right: 10,
        backgroundColor: "rgba(228, 228, 228, 1)",
        transition: t.transitions.create("right", {
            easing: t.transitions.easing.sharp,
            duration: t.transitions.duration.leavingScreen
        }),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff",
        borderRadius: 5,
        border: "1px solid rgba(0,0,0,1)"
    },
    seasonSelectOpen: {
        zIndex: 1e3,
        position: "absolute",
        top: 11,
        right: 340,
        backgroundColor: "rgba(228, 228, 228, 1)",
        transition: t.transitions.create("right", {
            easing: t.transitions.easing.sharp,
            duration: t.transitions.duration.enteringScreen
        }),
        width: 256,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        background: "#fff",
        borderRadius: 5,
        border: "1px solid rgba(0,0,0,1)",
    },
    seasonSelectClose: {
        zIndex: 1e3,
        position: "absolute",
        top: 11,
        right: 80,
        backgroundColor: "rgba(228, 228, 228, 1)",
        transition: t.transitions.create("right", {
            easing: t.transitions.easing.sharp,
            duration: t.transitions.duration.leavingScreen
        }),
        width: 256,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        background: "#fff",
        borderRadius: 5,
        border: "1px solid rgba(0,0,0,1)",
    },
    seasonalForecastButtonOpen: {
        zIndex: 1e3,
        position: "absolute",
        top: 11,
        // right: 696,
        right: 342,
        width: 50,
        height: 50,
        backgroundColor: "rgba(228, 228, 228, 1)",
        transition: t.transitions.create("right", {
            easing: t.transitions.easing.sharp,
            duration: t.transitions.duration.enteringScreen
        }),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff",
        borderRadius: 5,
        border: "1px solid rgba(0,0,0,1)"
    },
    seasonalForecastButtonClose: {
        zIndex: 1e3,
        position: "absolute",
        top: 11,
        width: 50,
        height: 50,
        // right: 336,
        right: 82,
        backgroundColor: "rgba(228, 228, 228, 1)",
        transition: t.transitions.create("right", {
            easing: t.transitions.easing.sharp,
            duration: t.transitions.duration.leavingScreen
        }),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff",
        borderRadius: 5,
        border: "1px solid rgba(0,0,0,1)"
    },
    menuGroupStyle: {
        borderBottom: '1px lightgrey solid'
        // borderLeft: '3px lightgrey solid',
    },
    mapOpen: {
        height: '100vh', width: '100%', width: 'calc(100%)', marginLeft: '0px',
    },
    mapClosed: {
        height: '100vh', width: '100%', width: 'calc(100% - 270px)', marginLeft: '0px',
        transition: t.transitions.create("width", {
            easing: t.transitions.easing.sharp,
            duration: t.transitions.duration.enteringScreen
        }),
    },
    open_button: { backgroundColor: 'rgb(155, 151, 88, 1)', color: 'white', marginLeft: '10px' },
    sensor_span: {
        alignSelf: 'center',
        width: '25px',
        height: '25px',
        marginLeft: '4%',
        // backgroundColor: 'lightgrey',
        cursor: 'pointer',
        textAlign: 'center',
        lineHeight: '25px',
        borderRadius: '5px'
    },
    topBarItem: {
        fontFamily: 'Roboto',
        fontSize: '13px',
        height: '36px',
        '&:hover': {
            backgroundColor: '#d6d6d4',
        },
        '& > svg': {
            marginRight: '8px',
            marginRight: '8px',
        },
        display: 'flex',
        alignItems: 'center',
        padding: '0 18px 0 8px',
        position: 'relative',
        '&:after': {
            content: '""',
            width: '1px',
            height: '26px',
            position: 'absolute',
            right: '0px',
            backgroundColor: '#d6d6d4',
            top: '50%',
            transform: 'translateY(-50%)',
        },
        '&:last-of-type:after': {
            display: 'none',
        },
        borderRadius: '6px',
        cursor: 'pointer',
        userSelect: 'none',
    },
    polygonDropdown: {
        position: 'absolute',
        top: 'calc(100% + 8px)',
        left: '0',
        minWidth: '160px',
        padding: '6px 0',
        backgroundColor: '#ffffff',
        zIndex: 1000,
        borderRadius: '10px',
        boxShadow: '0 12px 24px rgba(15, 30, 60, 0.18)',
        border: '1px solid rgba(0,0,0,0.08)',
    },
    polygonDropdownBtn: {
        fontSize: '13px',
        textAlign: 'left',
        borderRadius: '6px',
        padding: '10px 14px',
        '&:hover': {
            backgroundColor: '#f1f5f9',
        },
    },
    seasonDropDown: {
        color: '#333333',
        fontFamily: 'Roboto',
        fontSize: '15px',
        border: 'none',
        borderBottom: '1px solid #333333',
        marginRight: '20px',
        cursor: 'pointer',
        '&:focus': {
            outline: 'none',
        },
    },
    fieldInfoPanel: {
        position: 'absolute',
        top: 116,
        right: 18,
        bottom: 18,
        width: 'min(430px, 45%)',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
        padding: '20px 24px 24px 24px',
        zIndex: 2500,
        overflowY: 'auto'
    },
    fieldInfoHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '16px'
    },
    fieldInfoTitle: {
        fontSize: '18px',
        fontWeight: 600,
        color: '#2d3a4b'
    },
    fieldInfoCloseButton: {
        padding: '4px'
    },
    fieldInfoSection: {
        padding: '12px 0',
        borderTop: '1px solid #e6e6e6'
    },
    fieldInfoRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '8px'
    },
    fieldInfoLabel: {
        fontSize: '12px',
        color: '#6f7a83',
        marginRight: '12px'
    },
    fieldInfoValue: {
        fontSize: '13px',
        color: '#1d2733',
        fontWeight: 500,
        textAlign: 'right'
    },
    fieldInfoSubtitle: {
        fontSize: '13px',
        fontWeight: 600,
        color: '#2d3a4b',
        marginBottom: '8px'
    },
    filterResetButton: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '36px',
        padding: '0 20px',
        marginLeft: 'auto',
        backgroundColor: '#5EB3E4',
        color: '#ffffff',
        border: 'none',
        boxShadow: '0 3px 8px rgba(0, 0, 0, 0.18)',
        fontSize: '12px',
        fontWeight: 500,
        fontFamily: 'Roboto',
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease, box-shadow 0.2s ease, transform 0.1s ease',
        '&:hover': {
            backgroundColor: '#4FA2CD',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
        },
        '&:active': {
            transform: 'translateY(1px)',
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
        },
        '&:focus': {
            outline: 'none',
            boxShadow: '0 0 0 2px rgba(94, 179, 228, 0.35)',
        },
    },

});
